type DebugOptions = {
  prefix: string;
  shouldLogInStageEnv?: boolean;
};

export const debug = (
  options: DebugOptions | string,
  ...args: Array<unknown>
) => {
  const prefix = typeof options === 'string' ? options : options.prefix;
  const shouldLogInStageEnv =
    typeof options === 'string' ? false : options.shouldLogInStageEnv;

  if (
    (shouldLogInStageEnv ||
      import.meta.env.VITE_RUNTIME_ENV === 'development') &&
    import.meta.env.VITE_RUNTIME_ENV !== 'production'
  ) {
    window.console.info(`[${prefix}]`, ...args);
  }
};
